export default __webpack_public_path__ + "static/fonts/InclusiveSans-Light_aVbfiE.ttf";